import type { FC } from "react"
import { memo, useEffect, useRef } from "react"
import { useParams } from "react-router-dom"
import { GeoJsonLayer } from "@wayz/react-gl"
import { useRequest, useUpdate } from "ahooks-v2"
import { useMapValue } from "@/components/MapContainer/context"
import type { RouterIdsVO } from "@/api"
import { getGeojsonByCode } from "@/api"
import { colorToRGBArray } from "@/util/util"

const CityGeoJSONLayer: FC<any> = ({ id = "", zIndex = 1 }) => {
  const { cityId } = useParams<RouterIdsVO>() as any
  const { emitter } = useMapValue()
  const showTypeRef = useRef<string>("CITY")
  const update = useUpdate()

  const { data: geo } = useRequest(() => getGeojsonByCode(cityId), {
    ready: !!cityId,
    refreshDeps: [cityId],
  })

  useEffect(() => {
    const token = emitter.addListener("showTypeChange", (showType: string) => {
      showTypeRef.current = showType
      update()
    })
    return () => {
      token.remove()
    }
  }, [emitter, update])

  return (
    <GeoJsonLayer
      id={`city-path-layer${id ? "-" + id : ""}`}
      visible={!!geo}
      pickable={true}
      data={geo}
      stroked={true}
      getLineColor={colorToRGBArray("#0073FF")}
      getLineWidth={1}
      lineWidthUnits="pixels"
      getFillColor={[255, 255, 255, 0]}
      autoHighlight={false}
      // highlightColor={colorToRGBArray("rgb(255, 72, 72)", 0.6)}
      zIndex={zIndex}
    />
  )
}

export default memo(CityGeoJSONLayer)
